export interface Webhook {
  id: string
  accountId?: string
  name?: string
  enabled: boolean
  url?: string
  authType: WebhookAuthType
  authKey?: string
  authValue?: string
  events: WebhookEvent[]
  lastCalled?: string
  lastResponseStatus?: number
  lastResponseDetails?: string
}

export enum WebhookAuthType {
  None = 'None',
  Basic = 'Basic',
  Header = 'Header'
}

export enum WebhookEvent {
  TicketCreated = 'TicketCreated',
  TicketUpdated = 'TicketUpdated'
}
